<template>
  <div class="page flex overflow-x-auto pl-2 pb-16 gap-x-7 h-full">
    <div
        v-for="index in 6"
        :key="index"
        class="flex-none h-full rounded-xl text-white p-4"
        style="width: 504px; background-color: #333A53;"
    >
      <!-- ✅ 改为 flex-col 并占满高度 -->
      <div class="w-full h-full flex flex-col pt-2 pb-2 rounded-xl">

        <!-- 卡片头部 -->
        <div class="w-full pl-5 pr-5 pt-2 pb-2 flex justify-between text-white text-lg bg-purple-600 rounded-xl">
          <div class="w-1/3 flex flex-col items-start ">
            <div>娇娇</div>
            <div>ID：00001</div>
          </div>
        </div>

        <!-- 好友日志（长期记忆）标题 -->
        <div class="text-lg text-white mt-5">好友日志（长期记忆）</div>

        <!-- 时间轴区域：固定高度可滚动 -->
        <div class="mt-2 pl-5 w-full" style="height: 500px; overflow-y: auto">
          <el-timeline>
            <el-timeline-item
                v-for="(activity, index) in activities"
                :key="index"
                :timestamp="activity.timestamp"
                placement="top"
                color="#7E4BFA"
            >
              <h3 class="text-white" style="line-height: 1.5">{{ activity.content }}</h3>
              <img v-if="activity.image" :src="activity.image" class="mt-2"
                   style="width: 80%; max-height: 150px; object-fit: cover;"/>
            </el-timeline-item>
          </el-timeline>
        </div>

        <!-- 分隔线 -->
        <div class="my-4 border-t border-gray-600 ml-3 mr-3"></div>

        <!-- 查找输入框 -->
        <div class="flex justify-between mt-5 gap-x-5">
          <el-input
              v-model="name"
              placeholder="输入好友信息"
              maxlength="10"
              class="border-gray-700 text-white w-2/3 rounded-3xl"
          ></el-input>
          <el-button type="primary" class="bg-purple-600 hover:bg-purple-700 border-none w-1/3"
                     style="height: 45px; border-radius: 12px">
            查找好友
          </el-button>
        </div>

        <!-- 已关联好友标题 -->
        <div class="text-lg text-white mt-2">已关联好友</div>

        <!-- ✅ 关键修改：使用 flex-grow 布局 + 固定高度滚动容器 -->
        <div class="flex-grow overflow-hidden"> <!-- 占据剩余空间 -->
          <div
              class="w-full"
              style="height: 105px; overflow-y: auto; padding-right: 8px;"
          >
            <div
                class="flex flex-nowrap items-center mb-2"
                v-for="(item, index) in friends"
                :key="index"
                style="font-size: 16px;"
            >
              <div class="w-1/3">{{ item.name }}</div>
              <div class="w-1/3">{{ item.id }}</div>
              <div class="w-1/3 flex items-end justify-end">
                {{ item.status === 1 ? '解除' : '接受  拒绝' }}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>


<script>

export default {
  name: "FriendsPage",
  data() {
    return {
      name: '',
      friends: [{
        name: '敏敏',
        id: '123456',
        status: 2
      }, {
        name: '敏敏',
        id: '123456',
        status: 1
      }, {
        name: '敏敏',
        id: '123456',
        status: 1
      }, {
        name: '敏敏',
        id: '123456',
        status: 1
      }, {
        name: '敏敏',
        id: '123456',
        status: 1
      }, {
        name: '敏敏',
        id: '123456',
        status: 1
      }, {
        name: '敏敏',
        id: '123456',
        status: 1
      }],
      activities: [
        {
          timestamp: '2025年10月10日',
          content: '今天和东东去公园玩...',
          image: 'http://qzctec.com:8085/defaultAvatar/1.png'
        }, {
          timestamp: '2025年10月10日',
          content: '今天和东东去公园玩...',
          image: 'http://qzctec.com:8085/defaultAvatar/1.png'
        }, {
          timestamp: '2025年10月10日',
          content: '今天和东东去公园玩...',
          image: 'http://qzctec.com:8085/defaultAvatar/1.png'
        }, {
          timestamp: '2025年10月10日',
          content: '今天和东东去公园玩...',
          image: 'http://qzctec.com:8085/defaultAvatar/1.png'
        }, {
          timestamp: '2025年10月10日',
          content: '今天和东东去公园玩...',
          image: 'http://qzctec.com:8085/defaultAvatar/1.png'
        }, {
          timestamp: '2025年10月10日',
          content: '今天和东东去公园玩...',
          image: 'http://qzctec.com:8085/defaultAvatar/1.png'
        },
        {
          timestamp: '2025年10月10日',
          content: '今天和东东去公园玩...',
          image: 'http://qzctec.com:8085/defaultAvatar/1.png'
        },
        {
          timestamp: '2025年10月10日',
          content: '今天和东东去公园玩...',
          image: 'http://qzctec.com:8085/defaultAvatar/1.png'
        },
        {
          timestamp: '2025年10月10日',
          content: '今天和东东去公园玩...',
          image: 'http://qzctec.com:8085/defaultAvatar/1.png'
        }
      ]
    }
  },
  methods: {}
}
</script>


<style scoped>
/* 美化滚动条 */
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #555;
  border-radius: 3px;
}

/* 保持原有样式 */
::v-deep .el-timeline-item__tail {
  border-left: 2px solid #7E4BFA;
}

::v-deep .el-timeline-item__timestamp.is-top {
  position: absolute;
  left: -70px;
  color: #f0f0f0;
  width: 55px;
}

::v-deep .el-timeline {
  padding-left: 60px;
}

::v-deep .el-input__inner {
  background-color: #404761 !important;
  border-color: #4A4A6A !important;
  color: #fff !important;
  border-radius: 18px;
  font-size: 16px;
  height: 45px;
}
</style>